"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResultsForImageUpload = void 0;
const axios_1 = __importDefault(require("axios"));
const getResultsForImageUpload = (apiUrls_1, apiKey_1, meta_1, base64Image_1, ...args_1) => __awaiter(void 0, [apiUrls_1, apiKey_1, meta_1, base64Image_1, ...args_1], void 0, function* (apiUrls, apiKey, meta, base64Image, subjectId = '', username, appArgs, uvIndex, responseType = 'both', maxRetries = 5, intervalTime = 3000, expirationSeconds = '10000') {
    let uploadImageResponse = yield uploadHautAIImage(apiUrls.upload || '', apiKey, meta, base64Image, subjectId, username, appArgs, uvIndex);
    if (responseType === 'upload') {
        return { uploadImageResponse };
    }
    let imageResultsResponse = yield getPolledHautAIImageResults(apiUrls.results || '', apiKey, meta, uploadImageResponse.data, maxRetries, intervalTime, expirationSeconds);
    if (responseType === 'results') {
        return { imageResultsResponse };
    }
    return { uploadImageResponse, imageResultsResponse };
});
exports.getResultsForImageUpload = getResultsForImageUpload;
const uploadHautAIImage = (apiUrl_1, apiKey_1, meta_1, base64Image_1, ...args_1) => __awaiter(void 0, [apiUrl_1, apiKey_1, meta_1, base64Image_1, ...args_1], void 0, function* (apiUrl, apiKey, meta, base64Image, subjectId = '', username, appArgs, uvIndex) {
    try {
        const payloadData = {
            meta,
            data: {
                subjectId,
                username,
                appArgs,
                uvIndex,
                imageData: base64Image,
            },
        };
        if (!payloadData || !Object.keys(payloadData).length || !payloadData.data.username || !payloadData.data.imageData) {
            throw new Error('@AIBA[uploadHautAIImage]: Required payload data is missing');
        }
        const response = yield axios_1.default.post(apiUrl, payloadData, {
            headers: { 'x-api-key': apiKey },
            responseType: 'json',
        });
        return response.data;
    }
    catch (error) {
        console.error('@AIBA[uploadHautAIImage] error:', error);
        throw new Error('Haut Image Upload Failed');
    }
});
const getPolledHautAIImageResults = (apiUrl, apiKey, meta, hautAIMeta, maxRetries, intervalTime, expirationSeconds) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        let retryCount = 0;
        const intervalId = setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                let results = yield getHautAIImageResults(apiUrl, apiKey, meta, hautAIMeta, expirationSeconds);
                let { enhancedImage, degradedImage } = yield sanitizeHautImageResults(results.data.skingpt);
                if (enhancedImage && degradedImage && enhancedImage.length && degradedImage.length) {
                    clearInterval(intervalId);
                    resolve({ enhancedImage, degradedImage });
                }
                else if (retryCount >= maxRetries) {
                    clearInterval(intervalId);
                    reject(new Error(`Error fetching Skin GPT results after retries: ${maxRetries}`));
                }
                retryCount++;
            }
            catch (error) {
                clearInterval(intervalId);
                reject(error);
            }
        }), intervalTime);
    });
});
const getHautAIImageResults = (apiUrl, apiKey, meta, hautAIMeta, expirationSeconds) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const payloadData = {
            meta,
            data: Object.assign(Object.assign({}, hautAIMeta), { expiration_seconds: expirationSeconds }),
        };
        if (!payloadData ||
            !Object.keys(payloadData).length ||
            !payloadData.data.subjectId ||
            !payloadData.data.datasetId ||
            !payloadData.data.companyId ||
            !payloadData.data.batchId ||
            !payloadData.data.imageId) {
            throw new Error('@AIBA[getHautAIImageResults]: Required payload data is missing');
        }
        const response = yield axios_1.default.post(apiUrl, payloadData, {
            headers: { 'x-api-key': apiKey },
            responseType: 'json',
        });
        return response.data;
    }
    catch (error) {
        console.error('@AIBA[getHautAIImageResults] error:', error);
        throw new Error('Haut Image Results Failed');
    }
});
const sanitizeHautImageResults = (skinGPTResults) => __awaiter(void 0, void 0, void 0, function* () {
    let enhancedResult = skinGPTResults.filter(item => item.aux_image_type.tech_name === 'skingpt_generated' && item.meta.prompt.name === 'UV Enhancement');
    let degradedResult = skinGPTResults.filter(item => item.aux_image_type.tech_name === 'skingpt_generated' && item.meta.prompt.name === 'UV Degradation');
    let [enhancedImage, degradedImage] = [
        enhancedResult && enhancedResult[0] && enhancedResult[0].signed_url ? enhancedResult[0].signed_url : '',
        degradedResult && degradedResult[0] && degradedResult[0].signed_url ? degradedResult[0].signed_url : '',
    ];
    return { enhancedImage, degradedImage };
});
